import {Component, OnInit, inject} from '@angular/core';
import {AuthenticationService} from '../_services/authentication.service';
import {first} from 'rxjs/operators';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-site-map',
    templateUrl: './site-map.component.html',
    styleUrls: ['./site-map.component.scss'],
    imports: [RouterLink, TranslateModule]
})
export class SiteMapComponent implements OnInit {
  
  isLoggedIn: boolean = false;
  isTuAdmin: boolean = false;
  isAdmin: boolean = false;
  isBusiness: boolean = false;
  isConsumer: boolean = false;

  private readonly auth = inject(AuthenticationService);

  ngOnInit(): void {
    this.auth.isUserLoggedIn$.pipe(first()).subscribe(v => this.isLoggedIn = v);
    this.auth.isTuAdmin$.pipe(first()).subscribe(v => this.isTuAdmin = v);
    this.auth.isAdmin$.pipe(first()).subscribe(v => this.isAdmin = v);
    this.auth.isBusiness$.pipe(first()).subscribe(v => this.isBusiness = v);
    this.auth.isConsumer$.pipe(first()).subscribe(v => this.isConsumer = v);
  }

}
